import http from "./http";

const UserService = {
  getSubscriptions: () => {
    return http.get('/api/get-subscriptions');
  },
  checkSession: () => {
    return http.get('/api/session');
  },
  getGoogleSSOLink: () => {
    return http.get('/google-sso');
  },
  submitUserFeedback: (data:any, loggedIn:boolean) => {
    if (loggedIn) {
      return http.post('/api/feedback', data);
    }
    return http.post('/feedback', data);
  }
}

export default UserService;